export class TravelsList {
    constructor(element) {
        this.domElements = {};
        this.filterValues = {};
        this.itemsPerStep = 24;
        this.currentStep = 1;
        this.FILTER_ACTIVE_CLASS = 'travels-list--filter-active';

        if (!this.initDomElements(element)) {
            return;
        }

        console.log('TravelList initialized');

        this.readFilterValues();
        this.setFilterValues();
        this.initForm();
        this.filterItems();
        this.initShowMoreBtn();
        this.initResetBtn();
        this.initTags();
        this.initMobileFilter();
    }

    initDomElements(element) {
        this.domElements.main = element;
        if (!this.domElements.main) return false;
        this.domElements.filters = this.domElements.main.querySelectorAll('.travels-list__filter');

        this.domElements.form = this.domElements.main.querySelector('.travels-list__filters__form');

        this.domElements.items = this.domElements.main.querySelectorAll('.travel-list-item');
        this.domElements.$items = Array.from(this.domElements.items);

        this.domElements.showMoreBtn = this.domElements.main.querySelector(
            '.travels-list__show-more-btn'
        );
        this.domElements.emptyAdvice = this.domElements.main.querySelector(
            '.travels-list__empty-advice'
        );
        this.domElements.resetBtns = this.domElements.main.querySelectorAll('.travels-list__filters__reset-btn, .travels-list__reset-btn');

        this.domElements.resultCounter = this.domElements.main.querySelector('.travels-list__result-counter');

        this.domElements.tagsContainer = this.domElements.main.querySelector('.travels-list__tags');
        this.domElements.tagTemplate = this.domElements.tagsContainer.querySelector('template');

        this.domElements.adjustSearchBtn = this.domElements.main.querySelector('.travels-list__adjust-search-btn');
        this.domElements.filterSection = this.domElements.main.querySelector('.travels-list__filter-section');
        this.domElements.closeFilterBtn = this.domElements.main.querySelector('.travels-list__filters__close-btn');
        this.domElements.submitFilterBtn = this.domElements.main.querySelector('.travels-list__filters__submit-btn');

        return true;
    }

    initTags() {
        this.tagTemplateContent = this.domElements.tagTemplate.content.querySelector('.travels-list__tags__item');
        this.renderTags();
    }

    renderTags() {
        // Clear existing tags (except the template)
        const tags = this.domElements.tagsContainer.querySelectorAll('.travels-list__tags__item');
        tags.forEach(tag => tag.remove());

        // Create tags for each active filter
        this.domElements.filters.forEach((filterEl) => {
            const filterName = filterEl.dataset.filterName;
            const filterType = filterEl.dataset.filterType;

            if (filterType === 'checkbox') {
                filterEl.querySelectorAll('input:checked').forEach((input) => {
                    const label = input.closest('label');
                    const titleEl = label ? label.querySelector('.travels-list-property__title') : null;
                    const title = titleEl ? titleEl.textContent.trim() : input.value;
                    this.addTag(filterName, input.value, title);
                });
            } else if (filterType === 'select') {
                filterEl.querySelectorAll('select').forEach((select) => {
                    if (select.value) {
                        const selectedOption = select.options[select.selectedIndex];
                        const title = selectedOption ? selectedOption.textContent.trim() : select.value;
                        this.addTag(filterName, select.value, title);
                    }
                });
            }
        });
    }

    addTag(filterName, value, title) {
        const tag = this.tagTemplateContent.cloneNode(true);
        tag.dataset.filterName = filterName;
        tag.dataset.filterValue = value;
        tag.querySelector('.travels-list__tags__item__title').textContent = title;

        const deleteBtn = tag.querySelector('.travels-list__tags__item__delete-btn');
        if (deleteBtn) {
            deleteBtn.addEventListener('click', (event) => {
                event.preventDefault();
                this.removeFilterValue(filterName, value);
            });
        }

        this.domElements.tagsContainer.appendChild(tag);
    }

    removeFilterValue(filterName, value) {
        this.domElements.filters.forEach((filterEl) => {
            if (filterEl.dataset.filterName === filterName) {
                const filterType = filterEl.dataset.filterType;
                if (filterType === 'checkbox') {
                    filterEl.querySelectorAll('input').forEach((input) => {
                        if (input.value === value) {
                            input.checked = false;
                        }
                    });
                } else if (filterType === 'select') {
                    filterEl.querySelectorAll('select').forEach((select) => {
                        if (select.value === value) {
                            select.selectedIndex = 0;
                        }
                    });
                }
            }
        });

        this.onChangeFilter();
    }

    initForm() {
        this.domElements.form.addEventListener('change', () => this.onChangeFilter());
//         this.domElements.form.addEventListener('submit', (event) => {
//             event.preventDefault();
//             this.onChangeFilter();
//         });
    }

    onChangeFilter() {
        console.log('Filter changed');
        this.readFilterValues();
        this.currentStep = 1;
        this.filterItems();
        this.renderTags();
    }

    setFilterValues() {
        this.domElements.filters.forEach((elm) => {
            const filterName = elm.dataset.filterName;
            const filterType = elm.dataset.filterType;

            if (filterType === 'checkbox') {
                elm.querySelectorAll('input').forEach((input) => {
                    const value = input.value;
                    if (this.filterValues[filterName] && this.filterValues[filterName].values.indexOf(value) > -1) {
                        input.checked = true;
                    }
                });
            } else if (filterType === 'select') {
                elm.querySelectorAll('select').forEach((select) => {
                    if (this.filterValues[filterName] && this.filterValues[filterName].values.length > 0) {
                        select.value = this.filterValues[filterName].values[0];
                    }
                });
            }
        });
    }

    readFilterValues() {
        this.domElements.filters.forEach((elm) => {
            const filterType = elm.dataset.filterType;
            if (filterType === 'select') {
                this.readFilterValueSelect(elm);
            } else {
                this.readFilterValueCheckboxes(elm);
            }
        });
        console.log('Filter values read:', this.filterValues);
    }

    readFilterValueSelect(filter) {
        const filterName = filter.dataset.filterName;
        const values = [];

        filter.querySelectorAll('select').forEach((select) => {
            if (select.value) {
                values.push(select.value);
            }
        });

        this.filterValues[filterName] = {
            type: 'select',
            values: values
        };
    }

    readFilterValueCheckboxes(filter) {
        const filterName = filter.dataset.filterName;
        const values = [];

        filter.querySelectorAll('input').forEach((input) => {
            if (input.checked) {
                values.push(input.value);
            }
        });

        this.filterValues[filterName] = {
            type: 'checkbox',
            values: values
        };
    }

    resetFilters() {
        console.log('Reset filters');
        this.domElements.filters.forEach((elm) => {
            elm.querySelectorAll('input').forEach((input) => {
                input.checked = false;
            });
            elm.querySelectorAll('select').forEach((select) => {
                select.selectedIndex = 0;
            });
        });

        this.onChangeFilter();
    }

    filterItems() {
        const maxVisibleItems = this.currentStep * this.itemsPerStep;
        let matchesCount = 0;

        for (let i = 0, len = this.domElements.$items.length; i < len; i += 1) {
            const item = this.domElements.$items[i];

            if (!this.isItemMatchFilters(item)) {
                this.hideItem(item);
                continue;
            }

            matchesCount += 1;
            if (matchesCount <= maxVisibleItems) {
                this.showItem(item);
            } else {
                this.hideItem(item);
            }
        }

        console.log('Filtered items: matches: ' + matchesCount + ', max visible: ' + maxVisibleItems + ', current step: ' + this.currentStep);

        if (this.domElements.showMoreBtn) {
            if (matchesCount > maxVisibleItems) {
                this.domElements.showMoreBtn.style.display = 'block';
            } else {
                this.domElements.showMoreBtn.style.display = 'none';
            }
        }

        if (matchesCount === 0) {
            this.showEmptyAdvice();
        } else {
            this.hideEmptyAdvice();
        }

        this.updateResultCounter(matchesCount);

        this.toggleFilterActiveClass();
    }

    updateResultCounter(count) {
        if (this.domElements.resultCounter) {
            this.domElements.resultCounter.textContent = count;
        }
    }

    showItem(item) {
        item.style.display = 'block';
    }

    hideItem(item) {
        item.style.display = 'none';
    }

    isItemMatchFilters(item) {
        for (const filterName in this.filterValues) {
            const selectedFilterValues = this.filterValues[filterName].values;
            if (selectedFilterValues.length === 0) continue;

            let itemValues = [];
            const itemValuesData = item.getAttribute('data-filter-' + filterName);

            if (itemValuesData) {
                if (itemValuesData.indexOf(',') > -1) {
                    itemValues = itemValuesData.split(',');
                } else {
                    itemValues.push(itemValuesData);
                }
            }

            // Check if ALL selected filter values are present in itemValues
            for (let i = 0; i < selectedFilterValues.length; i++) {
                let selectedValue = selectedFilterValues[i] + '';
                if (itemValues.indexOf(selectedValue) === -1) {
                    return false;
                }
            }
        }
        return true;
    }

    initShowMoreBtn() {
        if (this.domElements.showMoreBtn) {
            this.domElements.showMoreBtn.addEventListener('click', (event) => {
                event.preventDefault();
                this.countUpCurrentStep();
            });
        }
    }

    countUpCurrentStep() {
        this.currentStep += 1;
        console.log('Current step increased to: ' + this.currentStep);
        this.filterItems();
    }

    showEmptyAdvice() {
        if (this.domElements.emptyAdvice) {
            this.domElements.emptyAdvice.style.display = 'block';
            this.domElements.emptyAdvice.style.opacity = 0;
            this.domElements.emptyAdvice.style.transition = 'opacity 0.4s';
            setTimeout(() => {
                this.domElements.emptyAdvice.style.opacity = 1;
            }, 10);
        }
    }

    hideEmptyAdvice() {
        if (this.domElements.emptyAdvice) {
            this.domElements.emptyAdvice.style.display = 'none';
        }
    }

    initMobileFilter() {
        this.domElements.adjustSearchBtn.addEventListener('click', () => {
            this.openFilters();
        });

        this.domElements.closeFilterBtn.addEventListener('click', () => {
            this.closeFilters();
        });

        this.domElements.submitFilterBtn.addEventListener('click', () => {
            this.closeFilters();
        });
    }

    openFilters() {
        document.body.classList.add('mobile-filter-open');
    }

    closeFilters() {
        document.body.classList.remove('mobile-filter-open');
    }

    initResetBtn() {
        if (this.domElements.resetBtns) {
            this.domElements.resetBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.resetFilters();
                });
            });
        }
    }

    toggleFilterActiveClass() {
        if (this.isFilterActive()) {
            this.domElements.main.classList.add(this.FILTER_ACTIVE_CLASS);
            this.domElements.resetBtns.forEach((btn) => {
                btn.style.display = 'block';
            });
        } else {
            this.domElements.main.classList.remove(this.FILTER_ACTIVE_CLASS);
            this.domElements.resetBtns.forEach((btn) => {
                btn.style.display = 'none';
            });
        }
    }

    isFilterActive() {
        for (const filterName in this.filterValues) {
            const filterValue = this.filterValues[filterName].values;
            if (filterValue.length > 0) return true;
        }
        return false;
    }
}
